import { useNavigate } from "@tanstack/react-router";
import { useClient, useInfiniteTransactionOrders } from "creso-core/hooks";
import { Button, ButtonProps, cn } from "web-design-system";

export function TransactionTrigger(
  props: ButtonProps & { clientId?: number; className?: string; label?: string }
) {
  const navigate = useNavigate();

  const { clientId, label, ...rest } = props;

  const { data: client } = useClient(clientId as number, !!clientId);

  const { orders } = useInfiniteTransactionOrders(
    client?.investment_account as string,
    !!client?.investment_account
  );

  return (
    <div className={cn("relative", props.className)}>
      <Button
        variant="outline"
        {...rest}
        onClick={() => {
          navigate({
            to: ".",
            search: (prev) => ({
              ...{
                ...prev,
                modal: "transaction",
              },
              ...(clientId ? { client_id: clientId } : {}),
            }),
          });
        }}
      >
        {label ?? "New transaction"}
      </Button>
      {orders.length ? (
        <div className="h-2 w-2 rounded-full bg-destructive absolute -top-0.5 -right-0.5" />
      ) : null}
    </div>
  );
}
